export default __webpack_public_path__ + "static/media/pause.2f30a3db.svg";